import React from 'react';
import { Space } from 'antd';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Modal } from '@common/components';
import { DeleteOrganizationSupplierAttachment } from '@institutions/graphql';

type Props = {
  fileId: string;
  visible: boolean;
  onAction: (value: boolean) => void;
};

export function SuppliersManagementDeleteFileModal({
  fileId,
  visible,
  onAction,
}: Props) {
  const errorFilesMessage = () =>
    createMessage('error', 'Failed to delete file. Please try again.');

  const [deleteAttachment] = useMutation(DeleteOrganizationSupplierAttachment, {
    onCompleted: ({ deleteOrganizationSupplierAttachment }) => {
      if (deleteOrganizationSupplierAttachment?.success) {
        createMessage('success', 'File deleted!');
        onAction(false);
      } else {
        errorFilesMessage();
      }
    },
    onError: errorFilesMessage,
    refetchQueries: ['OrganizationSupplierAttachments', 'SupplierHistory'],
  });

  return (
    <Modal
      onOk={() =>
        deleteAttachment({
          variables: {
            organizationSupplierAttachmentId: fileId,
          },
        })
      }
      onCancel={() => onAction(false)}
      visible={visible}
      title="Confirm deleting file?"
      okText="Confirm Delete"
      cancelText="Cancel"
      danger
    >
      <Space direction="vertical" size="middle">
        After deletion, this document will not be listed as an attachment but
        will still be visible in History
      </Space>
    </Modal>
  );
}
